import { render, staticRenderFns } from "./securityset.vue?vue&type=template&id=0f1f1c9d&scoped=true"
import script from "./securityset.vue?vue&type=script&lang=ts"
export * from "./securityset.vue?vue&type=script&lang=ts"
import style0 from "./securityset.vue?vue&type=style&index=0&id=0f1f1c9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1f1c9d",
  null
  
)

export default component.exports